<template>
    <div>
        <div @dblclick="toggleEditable" v-if="isEditable">
        <EditEngagementInput :engagement-id="engagement.id" :input-text="engagement.target_due_date" input-type="number" field-name="target_due_date" @refetch-engagements="fetchNewEngagements" @toggle-editable="toggleEditable" />
        </div>
        <div @dblclick="toggleEditable"  class="text-center" v-else>
            {{ targetDueDate }}
        </div>
    </div>
</template>

<script>
export default {
    name: "engagement-target-due-date-cell"
}
</script>

<script setup>
import { defineProps, defineEmits, ref, computed } from 'vue';
import EditEngagementInput from './EditEngagementInput.vue';

const props = defineProps({
    engagement: Object
})

const targetDueDate = computed(() => {
    if(props.engagement.target_due_date){
        if(props.engagement.target_due_date === 1){
            return `${props.engagement.target_due_date}st`
        } else if (props.engagement.target_due_date === 2){
            return `${props.engagement.target_due_date}nd`
        } else {
            return `${props.engagement.target_due_date}th`
        } 
    } else {
        return '--'
    }
})

const isEditable = ref(false)

const emit = defineEmits(['refetch-engagements'])

function fetchNewEngagements(){
    emit('refetch-engagements')
}

function toggleEditable(){
    isEditable.value = !isEditable.value
}

</script>

